<template>
  <div v-if="currentAbonnement">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom de l'abonnement</span>
                  </td>
                  <td>
                    {{ currentAbonnement.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début</span>
                  </td>
                  <td>
                    {{ currentAbonnement.date_debut }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Centre de coût</span>
                  </td>
                  <td>
                    {{ currentAbonnement.centre_cout.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Devise</span>
                  </td>
                  <td>
                    {{
                      currentAbonnement.devise.symbole +
                      ' ( ' +
                      currentAbonnement.devise.nom +
                      ' )'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Fréquence</span>
                  </td>
                  <td>
                    {{ currentAbonnement.frequence.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date fin</span>
                  </td>
                  <td>
                    {{ currentAbonnement.date_fin }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Ligne budgétaire</span>
                  </td>
                  <td>
                    {{ currentAbonnement.ligne_budgetaire.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentAbonnement.created_by.prenom
                        ? currentAbonnement.created_by.prenom +
                          ' ' +
                          currentAbonnement.created_by.nom
                        : currentAbonnement.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-3">Période</th>
                <th class="col-3 text-center">Montant prévu</th>
                <th class="col-3 text-center">Montant réel (Facture)</th>
                <th class="col-3 text-center">Montant payé</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in currentAbonnement.plannings"
                :key="index"
                class="d-flex"
              >
                <td class="col-3" style="vertical-align: middle">
                  {{ item.periode }}
                </td>
                <td class="col-3 text-center" style="vertical-align: middle">
                  {{
                    formatWithCurrency(
                      item.montant_prevu,
                      currentAbonnement.devise.symbole
                    )
                  }}
                </td>
                <td class="col-3 text-center" style="vertical-align: middle">
                  {{
                    formatWithCurrency(
                      item.montant_reel,
                      currentAbonnement.devise.symbole
                    )
                  }}
                </td>
                <td class="col-3 text-center" style="vertical-align: middle">
                  {{
                    formatWithCurrency(
                      item.montant_paiement,
                      currentAbonnement.devise.symbole
                    )
                  }}
                </td>
              </tr>
              <tr
                v-if="currentAbonnement.plannings.length === 0"
                class="d-flex"
              >
                <td colspan="3" class="text-center col-12">Pas de données</td>
              </tr>
            </tbody>
            <tfoot class="font-weight-bold font-size-18">
              <tr class="d-flex">
                <td class="text-center col-3">TOTAL</td>
                <td class="text-center col-3">
                  {{
                    formatWithCurrency(total, currentAbonnement.devise.symbole)
                  }}
                </td>
                <td class="text-center col-3">
                  {{
                    formatWithCurrency(
                      totalReel,
                      currentAbonnement.devise.symbole
                    )
                  }}
                </td>
                <td class="text-center col-3">
                  {{
                    formatWithCurrency(
                      totalPaiement,
                      currentAbonnement.devise.symbole
                    )
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('abonnement', ['currentAbonnement']),
    total() {
      return window._.sumBy(
        this.currentAbonnement.plannings,
        (item) => Number(item.montant_prevu) * 1
      );
    },
    totalReel() {
      return window._.sumBy(
        this.currentAbonnement.plannings,
        (item) => Number(item.montant_reel) * 1
      );
    },
    totalPaiement() {
      return window._.sumBy(
        this.currentAbonnement.plannings,
        (item) => Number(item.montant_paiement) * 1
      );
    },
  },
  methods: {
    ...mapActions('abonnement', ['getAbonnement']),
    init() {
      this.getAbonnement(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
